export const seoUseCaseTitle = function(businesType:string):string{return `Intelligent ${businesType} Management Software`}